import { ReactNode } from "react";
import { LeftArrow } from "shared/ui/icons/LeftArrow";

type LayoutGroupShellProps = {
  onBack: () => void;
  children: ReactNode;
};

export const LayoutGroupShell = ({
  onBack,
  children,
}: LayoutGroupShellProps) => (
  <div className="gg-flex gg-w-full gg-flex-col gg-items-start gg-gap-6 sm:gg-block">
    <button
      type="button"
      onClick={onBack}
      data-testid="layout-back"
      data-layout-back
      className="gg-flex gg-items-center gg-gap-2 gg-rounded-full gg-border gg-border-[#D4D4DA] gg-bg-gray-100 gg-px-4 gg-py-2 gg-text-sm gg-tracking-wider gg-text-[#69687E] hover:gg-bg-gray-200 sm:gg-py-2.5"
    >
      <LeftArrow />
      Naar ontwerpen
    </button>
    {children}
  </div>
);
